module.exports = __webpack_public_path__ + "img/zhAward-2.211c8f0b.png";